import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Card, CardContent, Grid, Typography, Avatar} from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
    },
    content: {
        alignItems: 'center',
        display: 'flex',
    },
    title: {
        fontWeight: 700,
    },
    avatar: {
        backgroundColor: theme.palette.info.main,
        height: 56,
        width: 56,
    },
    icon: {
        height: 32,
        width: 32,
    },
    statusContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    },
    status: {
        marginRight: theme.spacing(1),
    },
    up: {
        color: theme.palette.error.main,
    },
    down: {
        color: theme.palette.info.main,
    },
    middle: {
        color: theme.palette.black,
    },
    caption: {
        marginLeft: theme.spacing(1),
    },
}));

function formatDate(date) {
    const d = new Date(date);
    let month = String(d.getMonth() + 1),
        day = String(d.getDate()),
        year = d.getFullYear();

    month = month.padStart(2, '0');
    day = day.padStart(2, '0');

    return [year, month, day].join('/');
}

const Yesterday = props => {
    const {className, ...rest} = props;
    const classes = useStyles(props);
    const date = new Date();
    date.setDate(date.getDate() - 1);

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    container
                    justify="space-between"
                >
                    <Grid item>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                            variant="body2"
                        >
                            Date
                        </Typography>
                        <Typography variant="h3">{formatDate(date)}</Typography>
                    </Grid>
                    <Grid item>
                        <Avatar className={classes.avatar}>
                            <CalendarTodayIcon className={classes.icon}/>
                        </Avatar>
                    </Grid>
                </Grid>
                <div className={classes.statusContainer}>
                    <Typography
                        className={classes.caption}
                        variant="caption"
                    >
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
};

Yesterday.propTypes = {
    className: PropTypes.string,
};

export default Yesterday;
